<template>
	<div class="entry" v-if="entry.horse">
		<div class="entry-header" :class="{ scratched: entry.scratched }">
			<template v-if="showNumberOdds">
				<span class="float-right odds">{{ entry.odds }}</span>
				<span class="serif number cloth-{{ entry.program_number | numeric }}">{{ entry.program_number }}</span>
			</template>
			<span class="serif title">{{ entry.horse.title }}</span>
		</div>
		<ul class="information no-bullet key-value">
			<li class="ellipsis" v-if="entry.jockey">
				<span class="key inactive uppercase">Jockey /</span>
				<span class="value"><a :href="entry.jockey.url">{{ entry.jockey.title }}</a></span>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		props: [ 'entry', 'race' ],
		computed: {
			showNumberOdds () {
				return this.race.field_status == '2';
			}
		}
	}
</script>



/** WEBPACK FOOTER **
 ** Entry.vue?019f66a5
 **/